import { Screen } from '~/screens/InternalNews/[id]/edit';

export const InternalNewsEdit: React.FC = () => <Screen />;
